import { render, staticRenderFns } from "./LandingAvatar.vue?vue&type=template&id=556e1dbb&scoped=true"
import script from "./LandingAvatar.vue?vue&type=script&lang=js"
export * from "./LandingAvatar.vue?vue&type=script&lang=js"
import style0 from "./LandingAvatar.vue?vue&type=style&index=0&id=556e1dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e1dbb",
  null
  
)

export default component.exports